import * as React from 'react';
import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';
import { useDispatch, useSelector } from 'react-redux';
import CircularProgress from '@mui/material/CircularProgress';
import { taskDetailModalToggle } from '../../redux/actions/taskDetail.action';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { regular } from '@fortawesome/fontawesome-svg-core/import.macro';
import { taskCatImg } from '../../utils/taskCatImg';
import moment from 'moment';
import useWindowSize from '../../hooks/useWindowSize';
import { useTranslation } from 'react-i18next';
import instance from '../../utils/axios';
import { apiErrorHandler } from '../../utils/errorHandler';
import { openSnackBar } from '../../redux/actions/snackbar.actions';
import { getApiUrl } from '../../utils/apiUrls';
import TaskModalBody from "./TaskModalBody.container"
import CustomToolTip from "../../components/custom-tooltip/CustomTooltip.component";
import { isValidUrl, isSecureUrl, sanitiseInput } from "../../utils/helperFn";
import CustomButtonLoader from "../../components/global/CustomButtonLoader.component"

const TaskDetailModalContainer = ({ eventData, joinModalData, joinModalDataHandler }) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const windowSize = useWindowSize();
  const modalState = useSelector(state => state.taskDetail.modal);

  const hoganRef = React.useRef(null);

  const modalImgRef = React.useRef(null);
  const modalHeadRef = React.useRef(null);
  const modalFootRef = React.useRef(null);
  const [contentHeight, setContentHeight] = React.useState(null);

  const [isLoading, setIsLoading] = React.useState(false);
  const [state, setState] = React.useState({
    status: modalState.status,
    data: modalState.data
  });

  React.useEffect(() => {
    setTimeout(() => {
      if (
        !!modalHeadRef.current &&
        !!modalImgRef.current &&
        !!modalFootRef.current
      ) {
        setContentHeight(
          window.innerHeight - (modalFootRef.current.clientHeight + 3)
        );
      }
    }, 100);
  }, [state]);

  React.useEffect(() => {
    setState({
      status: modalState.status,
      data: modalState.data
    })
  }, [modalState]);

  const toggleDrawer = (anchor, open) => (event) => {
    if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
      return;
    }

    dispatch(taskDetailModalToggle(null))
  };

  const getHoganTteTaskLink = async () => {
    try {
      setIsLoading(true);
      const token = localStorage.getItem("token");
      const res = await instance.post(
        getApiUrl("getThirdPartyLoginData"),
        {
          taskId: modalState.data.taskId,
          eventId: modalState.data.eventId
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (modalState?.data?.taskType === "TTE_ASSESSMENTS") {
        if (!!res.data.url) {
          // Security: Validate URL to prevent Open Redirect (CWE-601)
          const secureUrl = isSecureUrl(res.data.url, dispatch, t);
          if (!secureUrl) {
            setIsLoading(false);
            return;
          }
          // Safe: URL has been validated above
          window.open(secureUrl, "_blank");
        }
        setIsLoading(false);
        return;
      }
      if (res.data) {
        setIsLoading(false);
        
        // Security: Validate URL to prevent Open Redirect (CWE-601)
        const secureUrl = isSecureUrl(res.data.url, dispatch, t);
        if (!secureUrl) {
          return;
        }
        
        const params = res.data;
        const form = hoganRef.current;
        form.method = 'POST';
        // Safe: URL has been validated above
        form.action = secureUrl;   

        for (const key in params) {
          const input = document.createElement('input');
          if(input.name !== 'url') {
            input.type = 'hidden';
            input.name = key;
            input.value = params[key];
  
            form.appendChild(input);
          }
        }
        document.body.appendChild(form);      
        form.submit();
        form.innerHTML = '';

        return;
      }
    } catch (error) {
      setIsLoading(false);
      const errObj = apiErrorHandler(error);

      dispatch(
        openSnackBar({
          msg: t(errObj.statusText),
          type: "error",
        })
      );
    }
  }

  const getTaskLink = async () => {
    try {
      setIsLoading(true);
      const token = localStorage.getItem('token');

      const res = await instance.post(getApiUrl('getTaskLink'), {
        taskId: modalState.data.taskId,
        eventId: modalState.data.eventId
      }, {
        headers: {
          "Authorization": `Bearer ${token}`,
        }
      });

      if (res.data.success) {
        setIsLoading(false);
        
        // Security: Validate URL to prevent Open Redirect (CWE-601)
        const secureUrl = isSecureUrl(res.data.testLink, dispatch, t);
        if (!secureUrl) {
          return;
        }
        
        // Safe: URL has been validated above
        window.open(secureUrl, '_blank');
      }

      if (res.data.status === 'ERROR') {
        throw Error(res.data.message);
      }

    } catch (error) {
      setIsLoading(false);
      const errObj = apiErrorHandler(error);
      dispatch(openSnackBar({
        msg: t(errObj.statusText),
        type: 'error'
      }))
    }
  }
  const disabledButton = (
    val,
    tooltipMessage = null,
    icon,
    disableTooltip = false
  ) => {
    return (
      <CustomToolTip
        disableTooltip={disableTooltip} // default to show tooltip
        title={
          <p className="mb-0 text-white fw-medium cm-xs-txt">
            {!!tooltipMessage ? t(tooltipMessage) : t(val)}
          </p>
        }
      >
        <CustomButtonLoader
          showLoadingState={false}
          disabled={true}
          icon={icon}
          buttonLabel={t(`${t(val)}`)}
          colorTheme={"blue"}
          buttonStyle={"py-10 px-3 ms-0 cm-mar-left-icon"}
          handleOnClick={getTaskLink}
        />
      </CustomToolTip>
    );
  };
  const eventHandler = (interviewLink, taskStartDate, showPopup, taskType) => {
    // Security: Validate URL to prevent Open Redirect (CWE-601)
    const secureUrl = isSecureUrl(interviewLink, dispatch, t);
    if (!secureUrl) {
      return;
    }
    
    if (showPopup) {
      joinModalDataHandler({
        ...joinModalData,
        customDialogBoxToggle: true,
        interviewLink: secureUrl,
        taskStartDate,
        taskType: taskType,
      });
    } else {
      // Safe: URL has been validated above
      window.open(secureUrl, "_blank");
    }
  };

  const loadButton = (taskType) => {
    if(modalState.data.taskStatus.toLowerCase() === 'completed') {
      return <span className="btn bg-action-blue cm-locked-btn text-white cm-sm-txt fw-medium cm-sm-txt fw-medium cm-btn-resp cm-btn-radius">
      {t('completed')}
      <FontAwesomeIcon icon={regular('external-link')} className="ps-2" />
      </span>
    }

    if(modalState.data.taskStatus.toLowerCase() === 'expired') {
      return <span className="btn bg-action-blue cm-locked-btn text-white cm-sm-txt fw-medium cm-sm-txt fw-medium cm-btn-resp cm-btn-radius">
      {t('did_not_partake')}
      <FontAwesomeIcon icon={regular('external-link')} className="ps-2" />
      </span>
    }

    if (modalState.data?.taskControl === "LOCK" || modalState.data?.block ) {
      return disabledButton(
        "yet_to_be_unlocked",
        null,
        null,
        true
      );
    }

    if (modalState.data?.taskType === "FEEDBACK_SURVEY") {
      if (moment().isAfter(moment(modalState.data?.taskStartDate))) {
          let link
          if (!!modalState.data?.approverLink) {
            link = modalState.data?.approverLink
          }
          else if (!!modalState.data?.nominationLink) {
            link = modalState.data?.nominationLink
          }
          else {
            link = modalState.data?.selfLink
          }
        return (
          <CustomButtonLoader
            showLoadingState={false}
            disabled={false}
            icon={regular('external-link')}
            buttonLabel={t("launch_task")}
            colorTheme={"blue"}
            buttonStyle={"py-10 px-3 ms-0 cm-mar-left-icon"}
            handleOnClick={() => { 
              // Security: Validate URL to prevent Open Redirect (CWE-601)
              const secureUrl = isSecureUrl(link, dispatch, t);
              if (!secureUrl) return;
              // Safe: URL has been validated above
              window.open(secureUrl, "_blank");
            }}
          />
          )
      }
      return disabledButton(
        "yet_to_be_unlocked",
        null,
        null,
        true
      );
    }

    if (modalState.data?.taskMode === "OFFLINE") {
      if (["INTERVIEW", "GROUP_DISCUSSION"].includes(modalState.data?.taskType)) {
        // INTERVIEW GROUP_DISCUSSION
        if (!!modalState.data?.location) {
          const tooltipMessage = `${modalState.data?.taskType === "INTERVIEW"
            ? t("interview_location")
            : t("gd_location")
            }: ${modalState.data?.location}`;
          if (isValidUrl(modalState.data?.location)) {
            return !moment().isBetween(moment(modalState.data?.taskStartDate), moment(modalState.data?.taskEndDate)) ? disabledButton(
              t("launch_task"),
              null,
              regular("external-link"),
              true
            ) : (
                // location with link
                <CustomButtonLoader
                  showLoadingState={false}
                  disabled={modalState.data?.block}
                  icon={null}
                  buttonLabel={t(`${t("launch_task")}`)}
                  colorTheme={"blue"}
                  buttonStyle={"py-10 px-3 cm-mar-left-icon"}
                  handleOnClick={() => { 
                    if (!modalState.data?.block) {
                      // Security: Validate URL to prevent Open Redirect (CWE-601)
                      const secureUrl = isSecureUrl(modalState.data?.location, dispatch, t);
                      if (!secureUrl) return;
                      // Safe: URL has been validated above
                      window.open(secureUrl, "_blank");
                    }
                  }}
                />
            );
          }

          return (
            <CustomToolTip
              disableTooltip={modalState.data?.block}
              title={
                <p className="mb-0 text-white fw-medium cm-xs-txt">
                  {tooltipMessage}
                </p>
              }
            >
              <div>
                {/* 2 location without link */}
                <CustomButtonLoader
                  showLoadingState={false}
                  disabled={modalState.data?.block}
                  icon={null}
                  buttonLabel={t(`${t("location")}: ${modalState.data?.location}`)}
                  colorTheme={"blue"}
                  buttonStyle={"py-10 px-3 cm-pointer-none"}
                  handleOnClick={() => { }}
                />
              </div>
            </CustomToolTip>
          );
        } else {
          return disabledButton("yet_to_be_scheduled");
        }
      } else {
        // TEST
        return disabledButton(
          "join_in_person",
          "this_task_is_to_be_attended_offline_in_person"
        );
      }
    }
    if (["ASSESSMENT", "HOGAN_ASSESSMENTS","TTE_ASSESSMENTS"].includes(modalState.data?.taskType)) {
      if (!modalState.data.taskStartDate) {
        return disabledButton("yet_to_be_scheduled");
      }
      if (
        // !!modalState.data?.taskLink &&
        moment().isAfter(modalState.data.taskStartDate)
      ) {
        return (
          <CustomButtonLoader
            showLoadingState={false}
            disabled={modalState.data?.block}
            icon={regular("external-link")}
            buttonLabel={t(`${t("launch_task")}`)}
            colorTheme={"blue"}
            buttonStyle={"py-10 mx-0 px-3 cm-mar-left-icon"}
            handleOnClick={() =>
              !modalState.data?.block ?
              ["HOGAN_ASSESSMENTS","TTE_ASSESSMENTS"].includes(modalState.data?.taskType) ? getHoganTteTaskLink() : getTaskLink() : null
              
            }
          />
        );
      }
      return disabledButton("yet_to_be_unlocked");
    }

    if (["INTERVIEW","GROUP_DISCUSSION"].includes(modalState.data?.taskType)) {
      const showPopup = !moment().isSameOrAfter(
        moment(modalState.data?.taskStartDate).subtract(15, "minutes")
      );
      return !!modalState.data?.taskLink ? (

        // 3 interview gd test online
        <CustomButtonLoader
          showLoadingState={false}
          disabled={modalState.data?.block}
          icon={regular("external-link")}
          buttonLabel={t(`${t("launch_task")}`)}
          colorTheme={"blue"}
          buttonStyle={"py-10 px-3 cm-mar-left-icon"}
          handleOnClick={
            () => !modalState.data?.block && eventHandler(modalState.data?.taskLink, modalState.data?.taskStartDate, showPopup, taskType)
          }
        />
      ) : (
        disabledButton("yet_to_be_scheduled")
      );
    }

    if (moment().isBefore(modalState.data?.taskStartDate)) {
      return disabledButton("yet_to_be_unlocked");
    }

    if (
      moment().isBetween(moment(modalState.data?.taskStartDate), moment(modalState.data?.taskEndDate))
    ) {
      return (
        <CustomButtonLoader
          showLoadingState={false}
          disabled={modalState.data?.block}
          icon={regular("external-link")}
          buttonLabel={t(`${t("launch_task")}`)}
          colorTheme={"blue"}
          buttonStyle={"py-10 px-3 cm-mar-left-icon"}
          handleOnClick={!modalState.data?.block && getTaskLink}
        />
      );
    }

    if (moment().isAfter(modalState.data?.taskStartDate)) {
      return (
        <CustomButtonLoader
          showLoadingState={false}
          disabled={modalState.data?.block}
          icon={regular("external-link")}
          buttonLabel={t(`${t("launch_task")}`)}
          colorTheme={"blue"}
          buttonStyle={"py-10 px-3 cm-mar-left-icon"}
          handleOnClick={() => { }}
        />
      );
    }

    return null;
  };

  const loadTaskCat = () => {
    if (modalState.data.taskControl === "LOCK" || modalState.data?.block){
      return t("yet_to_be_unlocked")
    }
    if (modalState.data.taskMode === null) return modalState.data.taskType === 'ASSESSMENT' ? t("test") : modalState.data.taskType === "BTA" ? t("business_thinking_appraisal") : t(modalState.data.taskType.toLowerCase());

    if (modalState.data.taskType === "TTE_ASSESSMENTS") {
      return t("mercer_talent_enterprise")
    }
    if (modalState.data.taskType === "HOGAN_ASSESSMENTS") {
      return t("hogan_candidate_tasktype")
    }

    if (['online', 'offline', "ai"].includes(modalState.data.taskMode?.toLowerCase())) {
      
      if (!!modalState.data?.modeType) {
        return modalState.data?.modeType === 'ASSESSMENT' ? t("test") : modalState.data?.modeType === "BTA" ? t("business_thinking_appraisal") : t(modalState.data.modeType.toLowerCase())
      } else {
        return modalState.data.taskType === 'ASSESSMENT' ? t("test") : modalState.data.taskType === "BTA" ? t("business_thinking_appraisal") : t(modalState.data.taskType?.toLowerCase())
      }
    }
  }

  const preText = () => {
    if (
      modalState.data.taskType === "ASSESSMENT" &&
      (!modalState.data.taskStartDate ||
        (modalState.data.taskStartDate &&
          moment().isBefore(modalState.data.taskStartDate)))
    ) {
      return t("starts_on");
    }
    if (["INTERVIEW", "GROUP_DISCUSSION"].includes(modalState.data.taskType)) {
      return t("starts_on");
    }
    return t("deadline");
  };

  const postText = () => {
    if(modalState.data.taskType==="ASSESSMENT"){
      if(!modalState.data.taskStartDate){
        return t("yet_to_start")
      }
      if(moment().isAfter(modalState.data.taskStartDate)){
        return moment(modalState.data.taskEndDate).format(
          "MMM DD YYYY hh:mm A"
        )
      }
      return moment(modalState.data.taskStartDate).format(
        "MMM DD YYYY hh:mm A"
      )
    }
    if (["INTERVIEW", "GROUP_DISCUSSION"].includes(modalState.data.taskType)) {
      return !!modalState.data.taskStartDate
      ? moment(modalState.data.taskStartDate).format(
        "MMM DD YYYY hh:mm A"
      )
      : t(modalState.data.taskStatus.toLowerCase())
    }
    return moment(modalState.data.taskEndDate).format(
      "MMM DD YYYY hh:mm A"
    );
  };

  const coverPageHandler = () => {
    if(modalState.data.taskMode === "AI") {
      return "ai_led_session";
    }
    if (modalState.data.taskType === "TTE_ASSESSMENTS") {
      return modalState?.data?.originalTaskName;
    }
    if (modalState.data.taskType === "HOGAN_ASSESSMENTS") {
      switch (modalState?.data?.originalTaskName) {
        case "hogan_personality_inventory":
          return "hogan_hpi";
        case "hogan_development_survey":
          return "hogan_hds";
        case "motives_values_preferences_inventory":
          return "hogan_mvpi";
        default:
          return "hogan_hbri";
      }
    } else if (modalState.data.taskMode === null) {
      return modalState.data.taskType;
    } else if (!!modalState.data.modeType) {
      return modalState.data.modeType;
    } else {
      return "";
    }
  };

  const list = (anchor) => (
    <Box
      sx={{ width: windowSize.screenWidth <= 991 ? 'auto' : 800 }}
      role="presentation"
      onKeyDown={toggleDrawer(anchor, false)}
    >
      {modalState.data.taskType ==="HOGAN_ASSESSMENTS" && <form ref={hoganRef} target="_blank" />}
      <div className='d-flex flex-column' style={{ height: !!contentHeight ? `${contentHeight}px` : 'auto', overflow: "auto" }}>
        <div className="cm-taskdetail-modal-img position-relative" ref={modalImgRef}>
          <img className={`${modalState.data.taskControl === "LOCK" || modalState.data?.block?"cm-bg-blur":""}`} src={taskCatImg(coverPageHandler(), 'cover')} alt={modalState.data.taskName} />
          <div className="cm-taskdetail-modal-close rounded-circle d-flex align-items-center justify-content-center cm-pointer" onClick={toggleDrawer(anchor, false)}>
            <FontAwesomeIcon icon={regular('times')} className="text-white" />
          </div>
        </div>
        <div className="cm-taskdetail-modal-header" ref={modalHeadRef}>
          <h4 className='h6 fw-semibold text-blue-800 cm-fs-14'>{t(modalState.data.taskName)}</h4>
          <div className='cm-taskdetail-modal-categ d-flex align-items-center flex-wrap cm-sm-txt'>
            <span className='text-blue-gray-700 rounded-pill text-blue-gray-700 fw-medium cm-fs-12'>{loadTaskCat()}</span>
            {!(modalState.data.taskControl === "LOCK" || modalState.data.block )  && <span className="text-blue-gray-700 rounded-pill ms-1  text-blue-gray-700 fw-medium cm-fs-12 cm-txt-transform-none">
              <span className="text-blue-gray-500">
                {preText()}
                :
              </span>{" "}
              {postText()}
            </span>}
          </div>
        </div>
        {<TaskModalBody t={t} instructionData={modalState?.data?.taskDescription} taskId={modalState?.data?.taskId} documentTaskCount={modalState?.data?.documentTaskCount} taskType={modalState?.data?.taskType} eventData={eventData} contentHeight={contentHeight - 280} />}
      </div>
      <div className="cm-taskdetail-modal-footer" ref={modalFootRef}>
        {modalState.data.taskType !== "BTA" && <div className="cm-taskdetail-modal-footer-top d-flex align-items-center text-blue-gray-700 cm-fs-12">
          <FontAwesomeIcon icon={regular('external-link')} />
          <p className='my-0 cm-sm-txt fw-medium'>{t('task_launched_in_different_tab')}</p>
        </div>}
        <div className={`cm-taskdetail-modal-footer-bottom d-flex ${modalState.data.taskType === "BTA" ? "border-top border-blue-gray-300" : ""}`}>
          {loadButton(modalState.data.taskType)}
          <button className={`btn cm-trans-btn ${modalState.data.taskType === "BTA" && modalState.data?.taskTab !== "COMPLETED" ? "ms-0": "ms-2"}  cm-trans-btn-inner text-action-blue cm-sm-txt fw-medium cm-light-hover cm-btn-resp cm-btn-radius`} onClick={toggleDrawer(anchor, false)}>
            {t('close')}
          </button>
        </div>
      </div>
    </Box>
  );

  return (
    <React.Fragment>
      <Drawer
        anchor={"right"}
        open={state.status}
        onClose={toggleDrawer("right", false)}
        className={`${
          windowSize.isMobile
            ? "cm-tasklist-modal-wrapper-mob-fv"
            : "cm-tasklist-modal-wrapper"
        }`}
      >
        {!!modalState.data ? (
          list("right")
        ) : (
          <div className="py-4 d-flex align-items-center justify-content-center">
            <CircularProgress />
          </div>
        )}
      </Drawer>
    </React.Fragment>
  );
}

export default TaskDetailModalContainer;